module.exports = __webpack_public_path__ + "img/img4.5a825cae.png";